import { defineComponent as _defineComponent } from 'vue'
import commonCard from '../common-card.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'theme-class',
  props: {
    title: null,
    logo: null
  },
  setup(__props: any) {



return { __sfc: true,commonCard }
}

})